export const schema = {
    models: {
        AssistantDto: {
            name: 'AssistantDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                assistantId: {
                    name: 'assistantId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                instructions: {
                    name: 'instructions',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                tools: {
                    name: 'tools',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                model: {
                    name: 'model',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                modelName: {
                    name: 'modelName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                description: {
                    name: 'description',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                isForm: {
                    name: 'isForm',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                isSupplementary: {
                    name: 'isSupplementary',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                isTable: {
                    name: 'isTable',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                creator: {
                    name: 'creator',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'AssistantDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ClientVersionDto: {
            name: 'ClientVersionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                android: {
                    name: 'android',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                ios: {
                    name: 'ios',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ClientVersionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'public',
                                operations: ['read'],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: ['create', 'update', 'delete'],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultDto: {
            name: 'ConsultDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                authId: {
                    name: 'authId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                patientId: {
                    name: 'patientId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                catalogueTemplateId: {
                    name: 'catalogueTemplateId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                catalogueTemplateVersion: {
                    name: 'catalogueTemplateVersion',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                startDate: {
                    name: 'startDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                completionDate: {
                    name: 'completionDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                rating: {
                    name: 'rating',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                summary: {
                    name: 'summary',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                tags: {
                    name: 'tags',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                state: {
                    name: 'state',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                archived: {
                    name: 'archived',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                accuracy: {
                    name: 'accuracy',
                    isArray: false,
                    type: {
                        enum: 'Accuracy',
                    },
                    isRequired: false,
                    attributes: [],
                },
                stateTimestamps: {
                    name: 'stateTimestamps',
                    isArray: true,
                    type: {
                        nonModel: 'StateTimestampDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                templateVersion: {
                    name: 'templateVersion',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                finalisationStatus: {
                    name: 'finalisationStatus',
                    isArray: false,
                    type: {
                        enum: 'FinalisationStatus',
                    },
                    isRequired: false,
                    attributes: [],
                },
                finalisationNote: {
                    name: 'finalisationNote',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                finalisationRequestedAt: {
                    name: 'finalisationRequestedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                audio: {
                    name: 'audio',
                    isArray: false,
                    type: {
                        model: 'AudioDto',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'HAS_ONE',
                        associatedWith: ['id'],
                        targetNames: ['audioId'],
                    },
                },
                audioId: {
                    name: 'audioId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                forms: {
                    name: 'forms',
                    isArray: true,
                    type: {
                        model: 'FormDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                    association: {
                        connectionType: 'HAS_MANY',
                        associatedWith: ['consultId'],
                    },
                },
                entities: {
                    name: 'entities',
                    isArray: true,
                    type: {
                        nonModel: 'EntityDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                template: {
                    name: 'template',
                    isArray: false,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                templateDelta: {
                    name: 'templateDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                additionalTemplates: {
                    name: 'additionalTemplates',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                additionalTemplatesDelta: {
                    name: 'additionalTemplatesDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDeltaMap',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                matchedPatients: {
                    name: 'matchedPatients',
                    isArray: true,
                    type: {
                        nonModel: 'PatientDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                attachedPatient: {
                    name: 'attachedPatient',
                    isArray: false,
                    type: {
                        nonModel: 'PatientDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                attachments: {
                    name: 'attachments',
                    isArray: true,
                    type: {
                        nonModel: 'AttachmentDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                confirmedPatient: {
                    name: 'confirmedPatient',
                    isArray: false,
                    type: {
                        nonModel: 'ConfirmedPatientDetailDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byOwner',
                        fields: ['owner', 'startDate'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        AudioDto: {
            name: 'AudioDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                url: {
                    name: 'url',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                storageKey: {
                    name: 'storageKey',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                duration: {
                    name: 'duration',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'AudioDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultDiarizationDto: {
            name: 'ConsultDiarizationDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                diarization: {
                    name: 'diarization',
                    isArray: true,
                    type: {
                        nonModel: 'DiarizationDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultDiarizationDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultEntityDto: {
            name: 'ConsultEntityDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                entities: {
                    name: 'entities',
                    isArray: true,
                    type: {
                        nonModel: 'EntityDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: false,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultEntityDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultTranscriptionDto: {
            name: 'ConsultTranscriptionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                clientTranscription: {
                    name: 'clientTranscription',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                cloudTranscription: {
                    name: 'cloudTranscription',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultTranscriptionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultTemplateDto: {
            name: 'ConsultTemplateDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                template: {
                    name: 'template',
                    isArray: false,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                templateDelta: {
                    name: 'templateDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultTemplateDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultPatientDto: {
            name: 'ConsultPatientDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                patientId: {
                    name: 'patientId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                attachedPatient: {
                    name: 'attachedPatient',
                    isArray: false,
                    type: {
                        nonModel: 'PatientDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                matchedPatients: {
                    name: 'matchedPatients',
                    isArray: true,
                    type: {
                        nonModel: 'PatientDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultPatientDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byPatientId',
                        queryField: 'consultPatientDtosByPatientId',
                        fields: ['patientId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultAdditionalTemplateDto: {
            name: 'ConsultAdditionalTemplateDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                additionalTemplates: {
                    name: 'additionalTemplates',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                additionalTemplatesDelta: {
                    name: 'additionalTemplatesDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDeltaMap',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultAdditionalTemplateDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        QuestionnaireDto: {
            name: 'QuestionnaireDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                sourceUrl: {
                    name: 'sourceUrl',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                json: {
                    name: 'json',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                currentVersion: {
                    name: 'currentVersion',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                prompt: {
                    name: 'prompt',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                endpoint: {
                    name: 'endpoint',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                temperature: {
                    name: 'temperature',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topP: {
                    name: 'topP',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topK: {
                    name: 'topK',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                expectJsonOutput: {
                    name: 'expectJsonOutput',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                includeDatetime: {
                    name: 'includeDatetime',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                revisionNotes: {
                    name: 'revisionNotes',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                usageCount: {
                    name: 'usageCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                lastUsedAt: {
                    name: 'lastUsedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                ratingSum: {
                    name: 'ratingSum',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                ratingCount: {
                    name: 'ratingCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'QuestionnaireDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        QuestionnaireVersionDto: {
            name: 'QuestionnaireVersionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                questionnaireId: {
                    name: 'questionnaireId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                version: {
                    name: 'version',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                sourceUrl: {
                    name: 'sourceUrl',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                json: {
                    name: 'json',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                prompt: {
                    name: 'prompt',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                endpoint: {
                    name: 'endpoint',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                temperature: {
                    name: 'temperature',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topP: {
                    name: 'topP',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topK: {
                    name: 'topK',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                expectJsonOutput: {
                    name: 'expectJsonOutput',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                includeDatetime: {
                    name: 'includeDatetime',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                revisionNotes: {
                    name: 'revisionNotes',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                valueSetUrls: {
                    name: 'valueSetUrls',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                valueSetsExpandedAt: {
                    name: 'valueSetsExpandedAt',
                    isArray: false,
                    type: 'AWSTimestamp',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'QuestionnaireVersionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byQuestionnaire',
                        fields: ['questionnaireId', 'version'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultEvidenceDto: {
            name: 'ConsultEvidenceDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                sourceType: {
                    name: 'sourceType',
                    isArray: false,
                    type: {
                        enum: 'EvidenceSourceType',
                    },
                    isRequired: true,
                    attributes: [],
                },
                sourceName: {
                    name: 'sourceName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                mimeType: {
                    name: 'mimeType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                storageKey: {
                    name: 'storageKey',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                originSystem: {
                    name: 'originSystem',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                attachmentId: {
                    name: 'attachmentId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: {
                        enum: 'EvidenceStatus',
                    },
                    isRequired: true,
                    attributes: [],
                },
                failureReason: {
                    name: 'failureReason',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                extractedText: {
                    name: 'extractedText',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                extractedTextKey: {
                    name: 'extractedTextKey',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                included: {
                    name: 'included',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                processedAt: {
                    name: 'processedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultEvidenceDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        queryField: 'consultEvidenceDtosByConsult',
                        fields: ['consultId', 'createdAt'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: ['read'],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultTemplateVersionDto: {
            name: 'ConsultTemplateVersionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                version: {
                    name: 'version',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                template: {
                    name: 'template',
                    isArray: false,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                templateDelta: {
                    name: 'templateDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                additionalTemplates: {
                    name: 'additionalTemplates',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                additionalTemplatesDelta: {
                    name: 'additionalTemplatesDelta',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDeltaMap',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                evidenceIds: {
                    name: 'evidenceIds',
                    isArray: true,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                reason: {
                    name: 'reason',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                restoredFromVersion: {
                    name: 'restoredFromVersion',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultTemplateVersionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        queryField: 'consultTemplateVersionDtosByConsult',
                        fields: ['consultId', 'version'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: ['read'],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ConsultFailureLogDto: {
            name: 'ConsultFailureLogDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                logType: {
                    name: 'logType',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                occurredAt: {
                    name: 'occurredAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                kind: {
                    name: 'kind',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                step: {
                    name: 'step',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                errorName: {
                    name: 'errorName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                message: {
                    name: 'message',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                consultType: {
                    name: 'consultType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ConsultFailureLogDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {
                        subscriptions: null,
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byLogTypeAndOccurredAt',
                        fields: ['logType', 'occurredAt'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsultId',
                        fields: ['consultId', 'occurredAt'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                identityClaim: 'sub',
                                operations: ['read'],
                            },
                        ],
                    },
                },
            ],
        },
        FormDto: {
            name: 'FormDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                fhirResponseId: {
                    name: 'fhirResponseId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                patientId: {
                    name: 'patientId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                patientName: {
                    name: 'patientName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                sentDate: {
                    name: 'sentDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                sections: {
                    name: 'sections',
                    isArray: true,
                    type: {
                        nonModel: 'FormSectionDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                response: {
                    name: 'response',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                strippedFields: {
                    name: 'strippedFields',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'FormDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byOwner',
                        fields: ['owner', 'sentDate'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byConsult',
                        fields: ['consultId', 'sentDate'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                provider: 'oidc',
                                ownerField: 'owner',
                                allow: 'owner',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        HandshakeDto: {
            name: 'HandshakeDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                cpn: {
                    name: 'cpn',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'HandshakeDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'public',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        AuditLogDto: {
            name: 'AuditLogDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                consultId: {
                    name: 'consultId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                cpn: {
                    name: 'cpn',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'AuditLogDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ErrorLogDto: {
            name: 'ErrorLogDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                userId: {
                    name: 'userId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                description: {
                    name: 'description',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                snapshot: {
                    name: 'snapshot',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                snapshotKey: {
                    name: 'snapshotKey',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                deviceModel: {
                    name: 'deviceModel',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                osVersion: {
                    name: 'osVersion',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ErrorLogDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        EventLogDto: {
            name: 'EventLogDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                event: {
                    name: 'event',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                state: {
                    name: 'state',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                expiresAt: {
                    name: 'expiresAt',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'EventLogDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ObservationDto: {
            name: 'ObservationDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                authId: {
                    name: 'authId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                patientId: {
                    name: 'patientId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: {
                        enum: 'ObservationType',
                    },
                    isRequired: true,
                    attributes: [],
                },
                startDate: {
                    name: 'startDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
                completionDate: {
                    name: 'completionDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                state: {
                    name: 'state',
                    isArray: false,
                    type: {
                        enum: 'ObservationState',
                    },
                    isRequired: true,
                    attributes: [],
                },
                attachments: {
                    name: 'attachments',
                    isArray: true,
                    type: {
                        nonModel: 'AttachmentDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                stateTimestamps: {
                    name: 'stateTimestamps',
                    isArray: true,
                    type: {
                        nonModel: 'StateTimestampDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                metricsId: {
                    name: 'metricsId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ObservationDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'oidc',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        EwsObservation: {
            name: 'EwsObservation',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                respiratoryRate: {
                    name: 'respiratoryRate',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                oxygen: {
                    name: 'oxygen',
                    isArray: false,
                    type: {
                        enum: 'Oxygen',
                    },
                    isRequired: true,
                    attributes: [],
                },
                consciousness: {
                    name: 'consciousness',
                    isArray: false,
                    type: {
                        enum: 'ConsciousnessLevel',
                    },
                    isRequired: true,
                    attributes: [],
                },
                systolicBP: {
                    name: 'systolicBP',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                heartRate: {
                    name: 'heartRate',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                temperature: {
                    name: 'temperature',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                oxygenSaturation: {
                    name: 'oxygenSaturation',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'EwsObservations',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'oidc',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        SubscriptionDto: {
            name: 'SubscriptionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: {
                        enum: 'SubscriptionType',
                    },
                    isRequired: true,
                    attributes: [],
                },
                monthlyConsultLimit: {
                    name: 'monthlyConsultLimit',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                consultsUsedThisMonth: {
                    name: 'consultsUsedThisMonth',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                description: {
                    name: 'description',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                price: {
                    name: 'price',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                subsidy: {
                    name: 'subsidy',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                stripeId: {
                    name: 'stripeId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                stripePriceId: {
                    name: 'stripePriceId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                stripeProductId: {
                    name: 'stripeProductId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                startDate: {
                    name: 'startDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                endDate: {
                    name: 'endDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                lastUpgradeDate: {
                    name: 'lastUpgradeDate',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'SubscriptionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        SubscriptionDomainDto: {
            name: 'SubscriptionDomainDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                domain: {
                    name: 'domain',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                subsidy: {
                    name: 'subsidy',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'SubscriptionDomainDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        SubscriptionAccessCodeDto: {
            name: 'SubscriptionAccessCodeDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                redeemed: {
                    name: 'redeemed',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: true,
                    attributes: [],
                },
                expiresAt: {
                    name: 'expiresAt',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'SubscriptionAccessCodeDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        TemplateCatalogueDto: {
            name: 'TemplateCatalogueDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                content: {
                    name: 'content',
                    isArray: true,
                    type: {
                        nonModel: 'ContentDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                webContent: {
                    name: 'webContent',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                model: {
                    name: 'model',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                subscriptionId: {
                    name: 'subscriptionId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                retired: {
                    name: 'retired',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                currentVersion: {
                    name: 'currentVersion',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                usageCount: {
                    name: 'usageCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                lastUsedAt: {
                    name: 'lastUsedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                profession: {
                    name: 'profession',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                specialty: {
                    name: 'specialty',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                ratingSum: {
                    name: 'ratingSum',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                ratingCount: {
                    name: 'ratingCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                prompt: {
                    name: 'prompt',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                endpoint: {
                    name: 'endpoint',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                temperature: {
                    name: 'temperature',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topP: {
                    name: 'topP',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topK: {
                    name: 'topK',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                expectJsonOutput: {
                    name: 'expectJsonOutput',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                includeDatetime: {
                    name: 'includeDatetime',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                revisionNotes: {
                    name: 'revisionNotes',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                builtInType: {
                    name: 'builtInType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                outputOutline: {
                    name: 'outputOutline',
                    isArray: true,
                    type: {
                        nonModel: 'OutputSectionDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'TemplateCatalogueDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byOwner',
                        fields: ['owner', 'title'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'bySubscriptionId',
                        fields: ['subscriptionId', 'title'],
                    },
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byBuiltInType',
                        fields: ['builtInType'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'oidc',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        TemplateCatalogueVersionDto: {
            name: 'TemplateCatalogueVersionDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                templateCatalogueId: {
                    name: 'templateCatalogueId',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                version: {
                    name: 'version',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                content: {
                    name: 'content',
                    isArray: true,
                    type: {
                        nonModel: 'ContentDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                webContent: {
                    name: 'webContent',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                model: {
                    name: 'model',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                profession: {
                    name: 'profession',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                specialty: {
                    name: 'specialty',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                usageCount: {
                    name: 'usageCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                ratingSum: {
                    name: 'ratingSum',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                ratingCount: {
                    name: 'ratingCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                prompt: {
                    name: 'prompt',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                provider: {
                    name: 'provider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                endpoint: {
                    name: 'endpoint',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                temperature: {
                    name: 'temperature',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topP: {
                    name: 'topP',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                topK: {
                    name: 'topK',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                expectJsonOutput: {
                    name: 'expectJsonOutput',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                includeDatetime: {
                    name: 'includeDatetime',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                revisionNotes: {
                    name: 'revisionNotes',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                outputOutline: {
                    name: 'outputOutline',
                    isArray: true,
                    type: {
                        nonModel: 'OutputSectionDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'TemplateCatalogueVersionDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'byTemplateCatalogue',
                        fields: ['templateCatalogueId', 'version'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'oidc',
                                identityClaim: 'sub',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        TuhiUserDto: {
            name: 'TuhiUserDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                sub: {
                    name: 'sub',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                confidenceLevel: {
                    name: 'confidenceLevel',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
                firstName: {
                    name: 'firstName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                lastName: {
                    name: 'lastName',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                email: {
                    name: 'email',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                birthDate: {
                    name: 'birthDate',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                avatarUrl: {
                    name: 'avatarUrl',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                avatarStorageKey: {
                    name: 'avatarStorageKey',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                organizationId: {
                    name: 'organizationId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                facilityId: {
                    name: 'facilityId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                role: {
                    name: 'role',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                baseRole: {
                    name: 'baseRole',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                lastLoginAt: {
                    name: 'lastLoginAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                profession: {
                    name: 'profession',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                specialty: {
                    name: 'specialty',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                subscriptionId: {
                    name: 'subscriptionId',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                subscription: {
                    name: 'subscription',
                    isArray: false,
                    type: {
                        model: 'SubscriptionDto',
                    },
                    isRequired: false,
                    attributes: [],
                    association: {
                        connectionType: 'HAS_ONE',
                        associatedWith: ['id'],
                        targetNames: ['subscriptionId'],
                    },
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'TuhiUserDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'key',
                    properties: {
                        name: 'bySubscriptionId',
                        fields: ['subscriptionId', 'lastName'],
                    },
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
        ValueSetCacheDto: {
            name: 'ValueSetCacheDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: true,
                    attributes: [],
                },
                conceptsJson: {
                    name: 'conceptsJson',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                conceptCount: {
                    name: 'conceptCount',
                    isArray: false,
                    type: 'Int',
                    isRequired: false,
                    attributes: [],
                },
                expandedAt: {
                    name: 'expandedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                },
                expiresAt: {
                    name: 'expiresAt',
                    isArray: false,
                    type: 'AWSTimestamp',
                    isRequired: false,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                createdAt: {
                    name: 'createdAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
                updatedAt: {
                    name: 'updatedAt',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: false,
                    attributes: [],
                    isReadOnly: true,
                },
            },
            syncable: true,
            pluralName: 'ValueSetCacheDtos',
            attributes: [
                {
                    type: 'model',
                    properties: {},
                },
                {
                    type: 'auth',
                    properties: {
                        rules: [
                            {
                                allow: 'private',
                                provider: 'iam',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                            {
                                allow: 'private',
                                provider: 'oidc',
                                operations: [
                                    'create',
                                    'update',
                                    'delete',
                                    'read',
                                ],
                            },
                        ],
                    },
                },
            ],
        },
    },
    enums: {
        FormStatus: {
            name: 'FormStatus',
            values: ['CREATED', 'SUBMITTED', 'PENDING', 'DECLINED', 'APPROVED'],
        },
        Accuracy: {
            name: 'Accuracy',
            values: ['DEFAULT', 'HIGH'],
        },
        FinalisationStatus: {
            name: 'FinalisationStatus',
            values: ['DRAFT', 'READY', 'IN_PROGRESS', 'QUERIED', 'FILED'],
        },
        AttachmentType: {
            name: 'AttachmentType',
            values: ['PDF', 'IMAGE', 'DOCUMENT', 'VIDEO', 'AUDIO'],
        },
        EvidenceSourceType: {
            name: 'EvidenceSourceType',
            values: ['AUDIO', 'IMAGE', 'PDF', 'DOCUMENT', 'API'],
        },
        EvidenceStatus: {
            name: 'EvidenceStatus',
            values: ['PENDING', 'PROCESSING', 'READY', 'FAILED'],
        },
        ObservationType: {
            name: 'ObservationType',
            values: ['EWS'],
        },
        ObservationState: {
            name: 'ObservationState',
            values: ['STARTED', 'IN_PROGRESS', 'COMPLETED', 'CANCELLED'],
        },
        ConsciousnessLevel: {
            name: 'ConsciousnessLevel',
            values: ['ALERT', 'VERBAL', 'PAIN', 'UNRESPONSIVE'],
        },
        Oxygen: {
            name: 'Oxygen',
            values: [
                'ROOM_AIR',
                'LPM_1',
                'LPM_2',
                'LPM_3',
                'LPM_4',
                'LPM_5',
                'LPM_6',
                'LPM_7',
                'LPM_8',
                'LPM_9',
                'LPM_10',
                'LPM_11',
                'LPM_12',
                'LPM_13',
                'LPM_14',
                'LPM_15',
            ],
        },
        SubscriptionType: {
            name: 'SubscriptionType',
            values: [
                'EXEMPT',
                'FREE',
                'PAID_INDIVIDUAL',
                'PAID_ORGANISATION',
                'SUBSIDISED',
            ],
        },
    },
    nonModels: {
        VendorDto: {
            name: 'VendorDto',
            fields: {
                practiceName: {
                    name: 'practiceName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                hpiOrganisationNumber: {
                    name: 'hpiOrganisationNumber',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                hpiFacilityNumber: {
                    name: 'hpiFacilityNumber',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ProviderDto: {
            name: 'ProviderDto',
            fields: {
                details: {
                    name: 'details',
                    isArray: false,
                    type: {
                        nonModel: 'ProviderDetailsDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                address: {
                    name: 'address',
                    isArray: false,
                    type: {
                        nonModel: 'AddressDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ProviderDetailsDto: {
            name: 'ProviderDetailsDto',
            fields: {
                providerId: {
                    name: 'providerId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                providerTypeCode: {
                    name: 'providerTypeCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                firstName: {
                    name: 'firstName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                middleName: {
                    name: 'middleName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                surname: {
                    name: 'surname',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        AccPatientDto: {
            name: 'AccPatientDto',
            fields: {
                details: {
                    name: 'details',
                    isArray: false,
                    type: {
                        nonModel: 'PatientDetailsDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                occupationCode: {
                    name: 'occupationCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                contact: {
                    name: 'contact',
                    isArray: false,
                    type: {
                        nonModel: 'ContactDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                address: {
                    name: 'address',
                    isArray: false,
                    type: {
                        nonModel: 'AddressDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientDetailsDto: {
            name: 'PatientDetailsDto',
            fields: {
                nhi: {
                    name: 'nhi',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                firstName: {
                    name: 'firstName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                middleName: {
                    name: 'middleName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                surname: {
                    name: 'surname',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                dateOfBirth: {
                    name: 'dateOfBirth',
                    isArray: false,
                    type: 'AWSDate',
                    isRequired: false,
                    attributes: [],
                },
                gender: {
                    name: 'gender',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                ethnicityCode: {
                    name: 'ethnicityCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                otherEthnicity: {
                    name: 'otherEthnicity',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        ContactDto: {
            name: 'ContactDto',
            fields: {
                emailAddress: {
                    name: 'emailAddress',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                mobilePhone: {
                    name: 'mobilePhone',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                homePhone: {
                    name: 'homePhone',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                workPhone: {
                    name: 'workPhone',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        AddressDto: {
            name: 'AddressDto',
            fields: {
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                line1: {
                    name: 'line1',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                line2: {
                    name: 'line2',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                suburb: {
                    name: 'suburb',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                city: {
                    name: 'city',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                postCode: {
                    name: 'postCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                country: {
                    name: 'country',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        EmploymentDto: {
            name: 'EmploymentDto',
            fields: {
                inPaidEmployment: {
                    name: 'inPaidEmployment',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                employmentStatusCode: {
                    name: 'employmentStatusCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                otherEmployment: {
                    name: 'otherEmployment',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                workTypeCode: {
                    name: 'workTypeCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                employer: {
                    name: 'employer',
                    isArray: false,
                    type: {
                        nonModel: 'EmployerDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        EmployerDto: {
            name: 'EmployerDto',
            fields: {
                employerName: {
                    name: 'employerName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                address: {
                    name: 'address',
                    isArray: false,
                    type: {
                        nonModel: 'AddressDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        InjuryDto: {
            name: 'InjuryDto',
            fields: {
                accidentDate: {
                    name: 'accidentDate',
                    isArray: false,
                    type: 'AWSDate',
                    isRequired: false,
                    attributes: [],
                },
                accidentLocationCode: {
                    name: 'accidentLocationCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                accidentSceneCode: {
                    name: 'accidentSceneCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                causeOfAccident: {
                    name: 'causeOfAccident',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                involvesVehicle: {
                    name: 'involvesVehicle',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                medicalTreatmentInjury: {
                    name: 'medicalTreatmentInjury',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                workInjury: {
                    name: 'workInjury',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                sportingInjury: {
                    name: 'sportingInjury',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                sportNameCode: {
                    name: 'sportNameCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                gradualProcessInjury: {
                    name: 'gradualProcessInjury',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                admittedToHospital: {
                    name: 'admittedToHospital',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                injuryComments: {
                    name: 'injuryComments',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assistanceRequired: {
                    name: 'assistanceRequired',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                accContactProvider: {
                    name: 'accContactProvider',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        DiagnosisDto: {
            name: 'DiagnosisDto',
            fields: {
                diagnosisDescription: {
                    name: 'diagnosisDescription',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                diagnosisCode: {
                    name: 'diagnosisCode',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                diagnosisCodeType: {
                    name: 'diagnosisCodeType',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                diagnosisSide: {
                    name: 'diagnosisSide',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        WorkCapacityDto: {
            name: 'WorkCapacityDto',
            fields: {
                canResumeNormalWork: {
                    name: 'canResumeNormalWork',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                returnToNormalWorkDate: {
                    name: 'returnToNormalWorkDate',
                    isArray: false,
                    type: 'AWSDate',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        DeclarationDto: {
            name: 'DeclarationDto',
            fields: {
                providerDeclaration: {
                    name: 'providerDeclaration',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        StateTimestampDto: {
            name: 'StateTimestampDto',
            fields: {
                state: {
                    name: 'state',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                timestamp: {
                    name: 'timestamp',
                    isArray: false,
                    type: 'AWSDateTime',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        ConfirmedPatientDetailDto: {
            name: 'ConfirmedPatientDetailDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                givenNames: {
                    name: 'givenNames',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                familyName: {
                    name: 'familyName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                dateOfBirth: {
                    name: 'dateOfBirth',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                sexAtBirth: {
                    name: 'sexAtBirth',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                Address: {
                    name: 'Address',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        AttachmentDto: {
            name: 'AttachmentDto',
            fields: {
                attachmentId: {
                    name: 'attachmentId',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                attachmentType: {
                    name: 'attachmentType',
                    isArray: false,
                    type: {
                        enum: 'AttachmentType',
                    },
                    isRequired: true,
                    attributes: [],
                },
                content: {
                    name: 'content',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                contentStorageKey: {
                    name: 'contentStorageKey',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                thumbnail: {
                    name: 'thumbnail',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                thumbnailStorageKey: {
                    name: 'thumbnailStorageKey',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        DiarizationDto: {
            name: 'DiarizationDto',
            fields: {
                confidence: {
                    name: 'confidence',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
                end: {
                    name: 'end',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                speaker: {
                    name: 'speaker',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                start: {
                    name: 'start',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                text: {
                    name: 'text',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        EntityDto: {
            name: 'EntityDto',
            fields: {
                entityConfidence: {
                    name: 'entityConfidence',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                entityEnd: {
                    name: 'entityEnd',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                entity_type: {
                    name: 'entity_type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                entityStart: {
                    name: 'entityStart',
                    isArray: false,
                    type: 'Float',
                    isRequired: true,
                    attributes: [],
                },
                entityText: {
                    name: 'entityText',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        TemplateDto: {
            name: 'TemplateDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'ID',
                    isRequired: false,
                    attributes: [],
                },
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                content: {
                    name: 'content',
                    isArray: true,
                    type: {
                        nonModel: 'ContentDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: true,
                },
                webContent: {
                    name: 'webContent',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                model: {
                    name: 'model',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                owner: {
                    name: 'owner',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        ContentDto: {
            name: 'ContentDto',
            fields: {
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                detail: {
                    name: 'detail',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                order: {
                    name: 'order',
                    isArray: false,
                    type: 'Int',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
        TemplateDeltaMap: {
            name: 'TemplateDeltaMap',
            fields: {
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                templates: {
                    name: 'templates',
                    isArray: true,
                    type: {
                        nonModel: 'TemplateDto',
                    },
                    isRequired: true,
                    attributes: [],
                    isArrayNullable: false,
                },
            },
        },
        FormSectionDto: {
            name: 'FormSectionDto',
            fields: {
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                rows: {
                    name: 'rows',
                    isArray: true,
                    type: {
                        nonModel: 'FormRowDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        FormRowDto: {
            name: 'FormRowDto',
            fields: {
                columns: {
                    name: 'columns',
                    isArray: true,
                    type: {
                        nonModel: 'FieldDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        FieldDto: {
            name: 'FieldDto',
            fields: {
                linkId: {
                    name: 'linkId',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                label: {
                    name: 'label',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                content: {
                    name: 'content',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                code: {
                    name: 'code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                system: {
                    name: 'system',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                codings: {
                    name: 'codings',
                    isArray: true,
                    type: {
                        nonModel: 'CodingDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
            },
        },
        CodingDto: {
            name: 'CodingDto',
            fields: {
                system: {
                    name: 'system',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                code: {
                    name: 'code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                display: {
                    name: 'display',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientDto: {
            name: 'PatientDto',
            fields: {
                id: {
                    name: 'id',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                identifiers: {
                    name: 'identifiers',
                    isArray: true,
                    type: {
                        nonModel: 'PatientIdentifierDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                names: {
                    name: 'names',
                    isArray: true,
                    type: {
                        nonModel: 'PatientNameDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                dateOfBirth: {
                    name: 'dateOfBirth',
                    isArray: false,
                    type: {
                        nonModel: 'PatientDateDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                dateOfDeath: {
                    name: 'dateOfDeath',
                    isArray: false,
                    type: {
                        nonModel: 'PatientDateDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                address: {
                    name: 'address',
                    isArray: true,
                    type: {
                        nonModel: 'PatientAddressDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                gender: {
                    name: 'gender',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                ethnicities: {
                    name: 'ethnicities',
                    isArray: true,
                    type: {
                        nonModel: 'EthnicityDto',
                    },
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                birthplace: {
                    name: 'birthplace',
                    isArray: false,
                    type: {
                        nonModel: 'BirthplaceDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                citizenship: {
                    name: 'citizenship',
                    isArray: false,
                    type: {
                        nonModel: 'CitizenshipDto',
                    },
                    isRequired: false,
                    attributes: [],
                },
                matchScore: {
                    name: 'matchScore',
                    isArray: false,
                    type: 'Float',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientIdentifierDto: {
            name: 'PatientIdentifierDto',
            fields: {
                use: {
                    name: 'use',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                system: {
                    name: 'system',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                assigner: {
                    name: 'assigner',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientNameDto: {
            name: 'PatientNameDto',
            fields: {
                name: {
                    name: 'name',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
                preferred: {
                    name: 'preferred',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                use: {
                    name: 'use',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                givenNames: {
                    name: 'givenNames',
                    isArray: true,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                    isArrayNullable: true,
                },
                familyName: {
                    name: 'familyName',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientDateDto: {
            name: 'PatientDateDto',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        PatientAddressDto: {
            name: 'PatientAddressDto',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                type: {
                    name: 'type',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                use: {
                    name: 'use',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        EthnicityDto: {
            name: 'EthnicityDto',
            fields: {
                value: {
                    name: 'value',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                code: {
                    name: 'code',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        BirthplaceDto: {
            name: 'BirthplaceDto',
            fields: {
                country: {
                    name: 'country',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                placeOfBirth: {
                    name: 'placeOfBirth',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        CitizenshipDto: {
            name: 'CitizenshipDto',
            fields: {
                source: {
                    name: 'source',
                    isArray: false,
                    type: 'String',
                    isRequired: false,
                    attributes: [],
                },
                status: {
                    name: 'status',
                    isArray: false,
                    type: 'Boolean',
                    isRequired: false,
                    attributes: [],
                },
            },
        },
        OutputSectionDto: {
            name: 'OutputSectionDto',
            fields: {
                title: {
                    name: 'title',
                    isArray: false,
                    type: 'String',
                    isRequired: true,
                    attributes: [],
                },
            },
        },
    },
    codegenVersion: '3.4.4',
    version: '50817d3af6c6d4c7b55fe4025ffabdcc',
}
